import httpRequest from "@/core/http-request";

//字典数据项API
export const dictionaryApi = {
  //设备分类
  deviceType: "10",
  //控制方式
  controlType: "20",

  pageDict(condition) {
    return httpRequest.get("/dict/page", { params: condition });
  },

  //根据类型加载字典数据
  async listDict(type) {
    var { data } = await httpRequest.get("/dict/list", {
      params: { dicType: type },
    });
    if (data && data.errorCode === "00000") {
      return data.result;
    } else {
      return [];
    }
  },
  saveDict(data) {
    return httpRequest.post("/dict/save", data);
  },

  deleteDict(ids) {
    return httpRequest.post("/dict/delete", ids);
  },
};
